import React from "react";

export const LanguageToggle = ({ lang, setLang, className }) => {
  return (
    <div
      className={className !== undefined ? className : "fixed top-6 right-20 z-[60]"}
      data-testid="language-toggle-wrapper"
    >
      <div className="glass bg-black/60 border border-white/10 rounded-full px-1 py-1 flex items-center gap-1 text-xs font-mono tracking-widest shadow-xl">
        <button
          onClick={() => setLang("en")}
          data-testid="lang-toggle-en"
          className={`px-4 py-2 rounded-full transition-all ${
            lang === "en"
              ? "bg-[var(--ph-accent)] text-black"
              : "text-neutral-400 hover:text-white"
          }`}
        >
          EN
        </button>
        <button
          onClick={() => setLang("pt")}
          data-testid="lang-toggle-pt"
          className={`px-4 py-2 rounded-full transition-all ${
            lang === "pt"
              ? "bg-[var(--ph-accent)] text-black"
              : "text-neutral-400 hover:text-white"
          }`}
        >
          PT
        </button>
        <button
          onClick={() => setLang("es")}
          data-testid="lang-toggle-es"
          className={`px-4 py-2 rounded-full transition-all ${
            lang === "es"
              ? "bg-[var(--ph-accent)] text-black"
              : "text-neutral-400 hover:text-white"
          }`}
        >
          ES
        </button>
      </div>
    </div>
  );
};

